import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  systemTemplates: [],
  paging: {},
  isLoading: false,
  isSuccess: false,
  isError: false,
  errorMessage: "",
};
export const systemTemplateSlice = createSlice({
  name: "systemTemplate",
  initialState: initialState,
  reducers: {
    systemTemplateRequest: (state) => ({
      ...state,
      isLoading: true,
      isSuccess: false,
      isError: false,
      errorMessage: "",
    }),
    systemTemplateSuccess: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      systemTemplates: action.payload,
    }),
    systemTemplateFailure: (state, action) => ({
      ...state,
      isLoading: false,
      isError: true,
      errorMessage: action.payload,
    }),
    setPaging: (state, action) => {
      state.paging = action.payload;
    },
  },
});
export const { systemTemplateRequest, systemTemplateSuccess, systemTemplateFailure, setPaging } =
  systemTemplateSlice.actions;
export default systemTemplateSlice.reducer;
